(function () {
  /*
   * UI制御の対象となるShopify Variant ID。
   */
  const TARGET_VARIANT_IDS = [
    "45240853430454",
    "45240853463222",
    "45240853397686",
    "45240853528758",
    "45240853627062",
    "45240853561526",
    "45240853594294",
    "45240853790902",
    "45240853659830",
    "45240853692598",
    "45240853725366",
    "45240853823670",
    "45240853856438",
    "45240853889206",
    "45240853921974",
    "45240853954742",
    "45240853987510",
    "45240854020278",
    "45240854053046",
    "45240854118582",
    "45240854085814",
    "45240854151350",
    "45240854184118",
    "45240854249654",
    "45098540662966",
    "45098540695734",
    "45098540630198"
  ];

  const TARGET_PATH_PREFIX =
    "/apps/floor-s/subscription";

  const ORIGINAL_ATTR =
    "data-mht-original-value";

  const HIDDEN_QUANTITY_ATTR =
    "data-mht-hidden-quantity";

  const NOTICE_CLASS =
    "mht-delivery-locked-message";

  const RETRY_INTERVAL_MS = 800;
  const MAX_RETRIES = 8;

  const MUTATION_RETRY_DELAY_MS = 50;
  const URL_WATCH_INTERVAL_MS = 500;

  const SKIP_REDIRECT_DELAY_MS = 6000;

  const SKIP_REDIRECT_FLAG_PREFIX =
    "mht-skip-redirect-done:";

  let lastUrl =
    location.href;

  let retryTimer =
    null;

  let retryCount =
    0;

  let skipHooked =
    false;

  let historyPatched =
    false;

  let navigationClickHooked =
    false;

  let isApplying =
    false;

  let mutationObserver =
    null;

  let mutationRetryTimer =
    null;

  let urlWatchTimer =
    null;

  function normalizeText(text) {
    return (text || "")
      .replace(/\u3000/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function isTargetPage() {
    return (
      window.location.pathname.indexOf(
        TARGET_PATH_PREFIX
      ) === 0
    );
  }

  function getRedirectFlagKey() {
    return (
      SKIP_REDIRECT_FLAG_PREFIX +
      location.pathname +
      location.search
    );
  }

  function clearRedirectFlag() {
    try {
      sessionStorage.removeItem(
        getRedirectFlagKey()
      );
    } catch (error) {}
  }

  function markRedirectDone() {
    try {
      sessionStorage.setItem(
        getRedirectFlagKey(),
        "1"
      );
    } catch (error) {}
  }

  function isRedirectDone() {
    try {
      return (
        sessionStorage.getItem(
          getRedirectFlagKey()
        ) === "1"
      );
    } catch (error) {
      return false;
    }
  }

  function parseJaDate(text) {
    const normalized =
      normalizeText(text);

    const match =
      normalized.match(
        /(\d{4})\/(\d{1,2})\/(\d{1,2})/
      );

    if (!match) {
      return null;
    }

    return new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      0,
      0,
      0,
      0
    );
  }

  function formatJaDate(date) {
    const year =
      date.getFullYear();

    const month =
      String(
        date.getMonth() + 1
      ).padStart(2, "0");

    const day =
      String(
        date.getDate()
      ).padStart(2, "0");

    return (
      year +
      "/" +
      month +
      "/" +
      day
    );
  }

  /*
   * 月曜日：
   * その週の金曜日
   *
   * 火曜日～日曜日：
   * 次の月曜日を基準とする金曜日
   */
  function calcDisplayDeliveryDateFromBillingDate(
    billingDate
  ) {
    const billing =
      new Date(
        billingDate.getFullYear(),
        billingDate.getMonth(),
        billingDate.getDate(),
        0,
        0,
        0,
        0
      );

    const day =
      billing.getDay();

    const cycleEndMonday =
      new Date(billing);

    const daysToMonday =
      day === 1
        ? 0
        : ((8 - day) % 7);

    cycleEndMonday.setDate(
      billing.getDate() +
      daysToMonday
    );

    cycleEndMonday.setHours(
      0,
      0,
      0,
      0
    );

    const delivery =
      new Date(
        cycleEndMonday
      );

    delivery.setDate(
      cycleEndMonday.getDate() + 4
    );

    delivery.setHours(
      0,
      0,
      0,
      0
    );

    return delivery;
  }

  /*
   * ラベルと値がpタグ2個の構造を最初に探す。
   *
   * 上側ブロックではp以外のタグが使用される場合があるため、
   * ラベル文字列と日付文字列を使った検索も行う。
   */
  function getTextRow(
    container,
    labelCandidates
  ) {
    if (!container) {
      return null;
    }

    const rows =
      Array.from(
        container.querySelectorAll(
          "div"
        )
      );

    for (
      const row of rows
    ) {
      const paragraphs =
        row.querySelectorAll(
          "p"
        );

      if (
        paragraphs.length < 2
      ) {
        continue;
      }

      const label =
        normalizeText(
          paragraphs[0].textContent
        );

      if (
        labelCandidates.includes(
          label
        )
      ) {
        return {
          row: row,
          labelEl: paragraphs[0],
          valueEl: paragraphs[1]
        };
      }
    }

    const labelElements =
      Array.from(
        container.querySelectorAll(
          "p, span, div, dt, dd, label, strong"
        )
      ).filter(
        function (element) {
          const text =
            normalizeText(
              element.textContent
            );

          return (
            labelCandidates.includes(
              text
            )
          );
        }
      );

    for (
      const labelElement of
      labelElements
    ) {
      let current =
        labelElement.parentElement;

      for (
        let depth = 0;
        current &&
        current !==
          container.parentElement &&
        depth < 6;
        depth += 1
      ) {
        const dateElements =
          Array.from(
            current.querySelectorAll(
              "p, span, div, dd, time"
            )
          ).filter(
            function (element) {
              if (
                element ===
                labelElement
              ) {
                return false;
              }

              const text =
                normalizeText(
                  element.textContent
                );

              return (
                /^\d{4}\/\d{1,2}\/\d{1,2}$/.test(
                  text
                )
              );
            }
          );

        if (
          dateElements.length > 0
        ) {
          const valueElement =
            dateElements.sort(
              function (a, b) {
                return (
                  a.children.length -
                  b.children.length
                );
              }
            )[0];

          return {
            row: current,
            labelEl: labelElement,
            valueEl: valueElement
          };
        }

        if (
          current === container
        ) {
          break;
        }

        current =
          current.parentElement;
      }
    }

    return null;
  }

  function setOriginalIfNeeded(
    element
  ) {
    if (
      !element.hasAttribute(
        ORIGINAL_ATTR
      )
    ) {
      element.setAttribute(
        ORIGINAL_ATTR,
        normalizeText(
          element.textContent
        )
      );
    }
  }

  function restoreOriginalIfNeeded(
    container,
    deliveryLabels
  ) {
    const row =
      getTextRow(
        container,
        deliveryLabels
      );

    if (!row) {
      return;
    }

    const original =
      row.valueEl.getAttribute(
        ORIGINAL_ATTR
      );

    if (original) {
      row.valueEl.textContent =
        original;

      row.valueEl.removeAttribute(
        ORIGINAL_ATTR
      );
    }
  }

  function ensureNotice(
    container,
    text
  ) {
    if (!container) {
      return;
    }

    let notice =
      container.querySelector(
        "." + NOTICE_CLASS
      );

    if (!notice) {
      notice =
        document.createElement(
          "p"
        );

      notice.className =
        NOTICE_CLASS;

      notice.style.marginTop =
        "12px";

      notice.style.fontSize =
        "14px";

      notice.style.lineHeight =
        "1.6";
      
      notice.style.whiteSpace =
        "pre-line";

      notice.style.color =
        "#666";

      container.appendChild(
        notice
      );
    }

    notice.textContent =
      text;
  }

  function removeNotices(
    container
  ) {
    if (!container) {
      return;
    }

    container
      .querySelectorAll(
        "." + NOTICE_CLASS
      )
      .forEach(
        function (element) {
          element.remove();
        }
      );
  }

  /*
   * 上側の「準備／配送中」ブロックを取得する。
   *
   * 「次回配送日」を起点に、次回配送日・決済日と
   * 2つの日付を含む最小の親ブロックを探す。
   */
  function findUpperBlock() {
    const deliveryLabels =
      Array.from(
        document.querySelectorAll(
          "p, span, div, dt, dd, label, strong"
        )
      ).filter(
        function (element) {
          return (
            normalizeText(
              element.textContent
            ) === "次回配送日"
          );
        }
      );

    for (
      const deliveryLabel of
      deliveryLabels
    ) {
      let current =
        deliveryLabel.parentElement;

      for (
        let depth = 0;
        current &&
        current !== document.body &&
        depth < 10;
        depth += 1
      ) {
        const text =
          normalizeText(
            current.textContent
          );

        const hasDeliveryDate =
          text.indexOf(
            "次回配送日"
          ) !== -1;

        const hasBillingDate =
          text.indexOf(
            "決済日"
          ) !== -1;

        const dates =
          text.match(
            /\d{4}\/\d{1,2}\/\d{1,2}/g
          ) || [];

        if (
          hasDeliveryDate &&
          hasBillingDate &&
          dates.length >= 2
        ) {
          return current;
        }

        current =
          current.parentElement;
      }
    }

    /*
     * STG構造用の予備判定。
     */
    const candidates =
      Array.from(
        document.querySelectorAll(
          "div"
        )
      ).filter(
        function (element) {
          const text =
            normalizeText(
              element.textContent
            );

          return (
            text.indexOf(
              "準備/配送中"
            ) !== -1 &&
            text.indexOf(
              "決済済み"
            ) !== -1 &&
            text.indexOf(
              "次回配送日"
            ) !== -1 &&
            text.indexOf(
              "決済日"
            ) !== -1
          );
        }
      );

    if (
      candidates.length === 0
    ) {
      return null;
    }

    return candidates.sort(
      function (a, b) {
        return (
          normalizeText(
            a.innerText || ""
          ).length -
          normalizeText(
            b.innerText || ""
          ).length
        );
      }
    )[0];
  }

  function findLowerBlock() {
    return document.querySelector(
      "#mikawaya-subscription-lines-delivery-plan"
    );
  }

  function getCurrentDetailScope() {
    if (!isTargetPage()) {
      return null;
    }

    return document.body;
  }

  /*
   * script、style、noscriptは過去注文情報が含まれる可能性が
   * あるため検索対象から除外する。
   */
  function isCurrentProductTarget() {
    if (!isTargetPage()) {
      return false;
    }

    const searchRoot =
      document.body.cloneNode(
        true
      );

    searchRoot
      .querySelectorAll(
        "script, style, noscript"
      )
      .forEach(
        function (element) {
          element.remove();
        }
      );

    const html =
      searchRoot.innerHTML || "";

    return TARGET_VARIANT_IDS.some(
      function (variantId) {
        return (
          html.indexOf(
            variantId
          ) !== -1
        );
      }
    );
  }

  function transformUpperBlock(
    container
  ) {
    if (!container) {
      return false;
    }

    const billingRow =
      getTextRow(
        container,
        ["決済日"]
      );

    const deliveryRow =
      getTextRow(
        container,
        ["次回配送日"]
      );

    if (
      !billingRow ||
      !deliveryRow
    ) {
      return false;
    }

    const billingDate =
      parseJaDate(
        billingRow.valueEl
          .textContent
      );

    if (!billingDate) {
      return false;
    }

    setOriginalIfNeeded(
      deliveryRow.valueEl
    );

    deliveryRow.valueEl.textContent =
      formatJaDate(
        calcDisplayDeliveryDateFromBillingDate(
          billingDate
        )
      );

    ensureNotice(
      container,
      "※【ミールセット】配送予定日は決済予定日が火曜日から翌月曜日までの場合、翌金曜日以降になります。\n" +
      "※【各種サプリメント】配送予定日は決済予定日が水曜日から翌火曜日までの場合、翌金曜日以降になります。"
    );

    return true;
  }

  function transformLowerBlock(
    container
  ) {
    if (!container) {
      return false;
    }

    const billingRow =
      getTextRow(
        container,
        ["決済予定日"]
      );

    const deliveryRow =
      getTextRow(
        container,
        ["配送予定日"]
      );

    if (
      !billingRow ||
      !deliveryRow
    ) {
      return false;
    }

    const billingDate =
      parseJaDate(
        billingRow.valueEl
          .textContent
      );

    if (!billingDate) {
      return false;
    }

    setOriginalIfNeeded(
      deliveryRow.valueEl
    );

    deliveryRow.valueEl.textContent =
      formatJaDate(
        calcDisplayDeliveryDateFromBillingDate(
          billingDate
        )
      );

    ensureNotice(
      container,
      "※【ミールセット】配送予定日は決済予定日が火曜日から翌月曜日までの場合、翌金曜日以降になります。\n" +
      "※【各種サプリメント】配送予定日は決済予定日が水曜日から翌火曜日までの場合、翌金曜日以降になります。"
    );

    return true;
  }

  function findQuantityRow() {
    const row =
      getTextRow(
        document.body,
        ["数量"]
      );

    return row
      ? row.row
      : null;
  }

  function hideQuantityRow() {
    const quantityRow =
      findQuantityRow();

    if (!quantityRow) {
      return false;
    }

    if (
      !quantityRow.hasAttribute(
        HIDDEN_QUANTITY_ATTR
      )
    ) {
      quantityRow.setAttribute(
        HIDDEN_QUANTITY_ATTR,
        quantityRow.style.display ||
          ""
      );
    }

    quantityRow.style.display =
      "none";

    return true;
  }

  function restoreQuantityRow() {
    document
      .querySelectorAll(
        "[" +
          HIDDEN_QUANTITY_ATTR +
          "]"
      )
      .forEach(
        function (row) {
          const originalDisplay =
            row.getAttribute(
              HIDDEN_QUANTITY_ATTR
            );

          row.style.display =
            originalDisplay || "";

          row.removeAttribute(
            HIDDEN_QUANTITY_ATTR
          );
        }
      );
  }

  function hideButtonsInScope(
    scope
  ) {
    if (!scope) {
      return;
    }

    scope
      .querySelectorAll(
        "button"
      )
      .forEach(
        function (button) {
          const text =
            normalizeText(
              button.textContent
            );

          if (
            text ===
              "配送日時を変更" ||
            text ===
              "定期コースを一時停止"
          ) {
            button.style.display =
              "none";
          }

          if (
            text === "スキップ"
          ) {
            button.style.display =
              "";
          }
        }
      );
  }

  function restoreButtonsInScope(
    scope
  ) {
    if (!scope) {
      return;
    }

    scope
      .querySelectorAll(
        "button"
      )
      .forEach(
        function (button) {
          const text =
            normalizeText(
              button.textContent
            );

          if (
            text ===
              "配送日時を変更" ||
            text ===
              "定期コースを一時停止" ||
            text ===
              "スキップ"
          ) {
            button.style.display =
              "";
          }
        }
      );
  }

  function restoreAll(scope) {
    const upperBlock =
      findUpperBlock();

    const lowerBlock =
      findLowerBlock();

    restoreOriginalIfNeeded(
      upperBlock,
      ["次回配送日"]
    );

    restoreOriginalIfNeeded(
      lowerBlock,
      ["配送予定日"]
    );

    removeNotices(
      upperBlock
    );

    removeNotices(
      lowerBlock
    );

    restoreButtonsInScope(
      scope || document.body
    );

    restoreQuantityRow();
  }

  function pauseMutationObserver() {
    if (mutationObserver) {
      mutationObserver.disconnect();
    }
  }

  function resumeMutationObserver() {
    if (
      !mutationObserver ||
      !document.documentElement
    ) {
      return;
    }

    mutationObserver.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );
  }

  function tryApply() {
    if (!isTargetPage()) {
      restoreAll(
        document.body
      );

      return true;
    }

    if (isApplying) {
      return false;
    }

    isApplying =
      true;

    pauseMutationObserver();

    try {
      const scope =
        getCurrentDetailScope();

      if (!scope) {
        return false;
      }

      if (
        !isCurrentProductTarget()
      ) {
        restoreAll(scope);

        return true;
      }

      hideButtonsInScope(
        scope
      );

      const quantityDone =
        hideQuantityRow();

      const upperDone =
        transformUpperBlock(
          findUpperBlock()
        );

      const lowerDone =
        transformLowerBlock(
          findLowerBlock()
        );

      return (
        upperDone ||
        lowerDone ||
        quantityDone
      );
    } catch (error) {
      console.error(
        "[mht] tryApply error:",
        error
      );

      return false;
    } finally {
      isApplying =
        false;

      resumeMutationObserver();
    }
  }

  function stopRetry() {
    if (retryTimer) {
      clearTimeout(
        retryTimer
      );

      retryTimer =
        null;
    }
  }

  function scheduleRetry() {
    stopRetry();

    retryCount =
      0;

    function loop() {
      const done =
        tryApply();

      retryCount +=
        1;

      if (
        done ||
        retryCount >= MAX_RETRIES
      ) {
        stopRetry();

        return;
      }

      retryTimer =
        setTimeout(
          loop,
          RETRY_INTERVAL_MS
        );
    }

    loop();
  }

  function observePageChanges() {
    if (mutationObserver) {
      resumeMutationObserver();

      return;
    }

    mutationObserver =
      new MutationObserver(
        function (mutations) {
          if (isApplying) {
            return;
          }

          const hasChildListChange =
            mutations.some(
              function (mutation) {
                return (
                  mutation.type ===
                    "childList" &&
                  (
                    mutation
                      .addedNodes
                      .length > 0 ||
                    mutation
                      .removedNodes
                      .length > 0
                  )
                );
              }
            );

          if (
            !hasChildListChange
          ) {
            return;
          }

          if (
            mutationRetryTimer
          ) {
            clearTimeout(
              mutationRetryTimer
            );
          }

          mutationRetryTimer =
            setTimeout(
              function () {
                mutationRetryTimer =
                  null;

                scheduleRetry();
              },
              MUTATION_RETRY_DELAY_MS
            );
        }
      );

    resumeMutationObserver();
  }

  function hardNavigateSamePage() {
    const url =
      new URL(
        window.location.href
      );

    url.searchParams.set(
      "mht_r",
      Date.now().toString()
    );

    console.log(
      "[mht] redirect to:",
      url.toString()
    );

    window.location.href =
      url.toString();
  }

  function schedulePostSkipRetryAndRedirect() {
    const delays = [
      300,
      1000,
      2000,
      3500
    ];

    delays.forEach(
      function (delay) {
        setTimeout(
          function () {
            tryApply();
          },
          delay
        );
      }
    );

    setTimeout(
      function () {
        if (
          isRedirectDone()
        ) {
          return;
        }

        markRedirectDone();
        hardNavigateSamePage();
      },
      SKIP_REDIRECT_DELAY_MS
    );
  }

  function onUrlChange() {
    if (
      location.href === lastUrl
    ) {
      return;
    }

    lastUrl =
      location.href;

    clearRedirectFlag();

    scheduleRetry();

    setTimeout(
      function () {
        scheduleRetry();
      },
      500
    );

    setTimeout(
      function () {
        scheduleRetry();
      },
      1500
    );
  }

  function patchHistoryMethods() {
    if (historyPatched) {
      return;
    }

    const rawPushState =
      history.pushState;

    const rawReplaceState =
      history.replaceState;

    history.pushState =
      function () {
        rawPushState.apply(
          this,
          arguments
        );

        onUrlChange();
      };

    history.replaceState =
      function () {
        rawReplaceState.apply(
          this,
          arguments
        );

        onUrlChange();
      };

    window.addEventListener(
      "popstate",
      onUrlChange
    );

    historyPatched =
      true;
  }

  function startUrlWatcher() {
    if (urlWatchTimer) {
      return;
    }

    urlWatchTimer =
      setInterval(
        function () {
          if (
            location.href ===
            lastUrl
          ) {
            return;
          }

          onUrlChange();
        },
        URL_WATCH_INTERVAL_MS
      );
  }

  function hookNavigationClicks() {
    if (
      navigationClickHooked
    ) {
      return;
    }

    document.addEventListener(
      "click",
      function (event) {
        const element =
          event.target instanceof
          Element
            ? event.target
            : null;

        if (!element) {
          return;
        }

        const clickable =
          element.closest(
            "a, button, [role='button']"
          );

        if (!clickable) {
          return;
        }

        /*
         * 画面遷移直後に即時実行し、
         * 100ms、500ms、1500ms後にも再確認する。
         */
        scheduleRetry();

        setTimeout(
          function () {
            scheduleRetry();
          },
          100
        );

        setTimeout(
          function () {
            scheduleRetry();
          },
          500
        );

        setTimeout(
          function () {
            scheduleRetry();
          },
          1500
        );
      },
      true
    );

    navigationClickHooked =
      true;
  }

  function hookSkipButton() {
    if (skipHooked) {
      return;
    }

    document.addEventListener(
      "click",
      function (event) {
        const element =
          event.target instanceof
          Element
            ? event.target
            : null;

        if (!element) {
          return;
        }

        const clickable =
          element.closest(
            'button, [role="button"], input[type="button"], input[type="submit"], a'
          );

        if (!clickable) {
          return;
        }

        const text =
          normalizeText(
            clickable.textContent ||
            clickable.value ||
            clickable.getAttribute(
              "aria-label"
            ) ||
            ""
          );

        if (
          text !== "スキップ"
        ) {
          return;
        }

        const modalLikeParent =
          clickable.closest(
            '[role="dialog"], [aria-modal="true"], .modal, .ReactModal__Content, .chakra-modal__content, .chakra-modal__dialog-container'
          );

        if (
          !modalLikeParent
        ) {
          return;
        }

        schedulePostSkipRetryAndRedirect();
      },
      true
    );

    skipHooked =
      true;
  }

  function init() {
    console.log(
      "[mht] subscription control initialized"
    );

    clearRedirectFlag();

    patchHistoryMethods();
    hookSkipButton();
    observePageChanges();
    startUrlWatcher();
    hookNavigationClicks();

    scheduleRetry();
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init
    );
  } else {
    init();
  }
})();